































































































import { Component, Vue } from 'vue-property-decorator'
import { addApp, updateAppInfo, checkAppNameIsExist } from '@/apps/open/services/app'
import { reqUploadImg } from '@/apps/open/utils'
import Button from '@/apps/open/components/Button'
import { APP_CENTER_URL, WPS_DOCS, OPEN_PLUS_WPS, priUrlReg } from '@/apps/open/constants'
import store from '@/apps/open/store'
import { IAppInfo } from '@/apps/open/store/modules/app/types'
import _ from 'lodash'

@Component({
  components: {
    Button
  },
  data: () => ({
    APP_CENTER_URL,
    OPEN_PLUS_WPS
  })
})
export default class AddApp extends Vue {
  info: IAppInfo = {
    is_sandbox: false,
    app_type: 1,
    is_add_to_app_center: false,
    app_mode: 0,
    open_company_id: undefined
  }
  companyList: any[] = []
  infoBeforeEdit: IAppInfo = {}
  uploadPercent = 0
  uploadState = 0
  WPS_DOCS: string = WPS_DOCS

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get isPriDocMiddle () {
    return this.$store.getters['isPriDocMiddle']
  }

  get curEnterprise (): any {
    return this.$store.getters['User/curEnterprise']
  }

  get rules () {
    const urlReg = new RegExp(
      priUrlReg,
      'i'
    )
    return {
      app_name: [
        { required: true, message: '请输入应用名称', trigger: 'blur' },
        { min: 1, max: 20, message: '长度不超过20个字符' },
        { pattern: /^[^@#¥%^&*<>?]+$/, message: '不合法的应用名称，请重新输入' },
        {
          validator: async (rule: any, value: any, callback: any) => {
            if (this.infoBeforeEdit.app_name && value === this.infoBeforeEdit.app_name) {
              return callback()
            }
            const res = await checkAppNameIsExist(value)
            if (res.data.is_exist) {
              return callback(new Error('应用名称已存在，请重新输入'))
            }
            return callback()
          },
          trigger: 'blur'
        }
      ],
      is_sandbox: [
        { required: true, message: '请选择应用类型', trigger: 'blur' }
      ],
      app_type: [
        { required: true, message: '请选择应用平台' }
      ],
      access_url: [
        { required: true, message: '请输入应用官网地址', trigger: 'blur' },
        { min: 1, max: 80, message: '长度不超过80个字符' },
        this.isPrivate ? { pattern: urlReg, message: '请输入正确的官网地址' } : { type: 'url', message: '请输入正确的官网地址' }
      ],
      desc: [
        { required: true, message: '请输入应用介绍', trigger: 'blur' },
        { min: 1, max: 80, message: '长度不超过80个字符' }
      ],
      logo: [
        { required: true, message: '请上传照片' }
      ],
      app_mode: [
        { required: true, message: '请选择应用模式' }
      ]
    }
  }

  /* get saveBtnStatus () {
    return this.isPrivate || (this.info.app_mode === 0 || this.info.open_company_id !== undefined)
  } */

  mounted () {
    let id = this.$route.params['id']
    if (id) {
      this.info.app_id = id
      this.loadAppInfo()
    }
    this.initDefaultAppMode()
    !this.isPrivate && this.loadCompanyList()
  }

  get isEdit () {
    return !!this.$route.params['id']
  }

  get uploadUrl () {
    return '/api/my/app/logo/_upload'
  }

  initDefaultAppMode () {
    if (this.curEnterprise.developer_type === 1) {
      (this.isPrivate || this.curEnterprise.status !== 1) && this.$set(this.info, 'app_mode', 2)
    } else if (this.curEnterprise.developer_type === 0 && this.isPriDocMiddle) {
      this.$set(this.info, 'app_mode', 1)
    }
  }

  async loadAppInfo () {
    if (!this.info.app_id) {
      return
    }
    this.$store.dispatch('App/GET_APP_INFO', this.info.app_id)
      .then((appInfo: IAppInfo) => {
        if (appInfo.app_type === 0) {
          delete appInfo.app_type
        }
        if (appInfo.app_mode === 2) {
          appInfo.open_company_id = _.get(appInfo, 'company.open_company_id', undefined)
          delete appInfo.company
        }
        this.info = { ...appInfo }
        this.infoBeforeEdit = { ...appInfo }
      }).catch((error) => {
        this.$message.error(error.message)
      })
  }

  loadCompanyList () {
    this.$store.dispatch('App/GET_COMPANY_LIST', this.curEnterprise && this.curEnterprise.developer_id).then(() => {
      this.companyList = _.get(this, `$store.getters['App/appInfo'].companyList`, [])
    }).catch(error => {
      this.$message.error(error.message)
    })
  }

  submit () {
    let ref: any = this.$refs['info']
    ref.validate((valid: any) => {
      let info:any = this.info
      if (valid) {
        if (info.app_mode === 0) {
          delete info.open_company_id
        }

        info.developer_id = this.curEnterprise.developer_id

        if (this.isPrivate) {
          const resetLogoUrl = (info.logo as string).indexOf('/openplatform')
          info.logo = (info.logo as string).substring(resetLogoUrl)
        }

        ;(info.app_id ? updateAppInfo : addApp)(info)
          .then(() => {
            this.$message.success(`${this.isEdit ? '修改' : '创建'}成功`)
            this.$router.push({ name: 'developer-info' })
          }).catch((error) => {
            this.$message.error(error.message)
          })
      } else {
        return false
      }
    })
  }

  onRequest (options: any) {
    reqUploadImg(options, this)
  }

  onBeforeUpload (file: any) {
    const isPNG = file.type === 'image/png'
    const isLtSize = file.size / 1024 < 300
    if (!isPNG) {
      this.$message.error('上传图片必须为png格式')
      return false
    }
    if (!isLtSize) {
      this.$message.error('上传图片大小不能超过300K')
      return false
    }
    return new Promise((resolve, reject) => {
      const width = 120
      const height = 120
      const _URL = window.URL
      const image = new Image()
      image.onload = () => {
        const valid = image.width === width && image.height === height
        valid ? resolve() : reject(new Error())
      }
      image.src = _URL.createObjectURL(file)
    }).then(() => {
      return file
    }, (err) => {
      this.$message.error('上传图片必须为120*120像素')
      return Promise.reject(err)
    })
  }
}
